var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.submodelElement !== undefined)?_c('div',[_c('reference-view',{key:"first",attrs:{"reference":_vm.getFirst}}),_vm._v("→ "),_c('reference-view',{key:"second",attrs:{"reference":_vm.getSecond}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }